import script from "./LevelRatio.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelRatio.vue?vue&type=script&setup=true&lang=js"

import "./LevelRatio.vue?vue&type=style&index=0&id=e917d846&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e917d846"]])

export default __exports__